<template>
  <div v-if="viewImg" class="ivu-modal-wrap ivu-modal-hisign" style="z-index: 199999;">
    <div class="preview-mask"></div>
    <div :class="[screenfull == 1? 'preview-wrap-full' : '','preview-wrap']">
      <div class="preview-title">
        <p class="preview-title-p">{{viewImg.name}}</p>
        <a class="h_cancel" @click="closeImg"></a>
        <a class="h_undo" @click="handle('reset')"><b>复原</b></a>
        <a class="h_rotateRight" @click="handle('rotate')"><b>旋转</b></a>
        <a class="h_zoom_out" @click="handle('scalesmall')"><b>缩小</b></a>
        <a class="h_zoom_in" @click="handle('scalelarge')"><b>放大</b></a>
        <!--<a class="h_download" :href="fileServerPath+viewImg" :download="viewImg.name"><b>下载</b></a>-->
        <a :class="[screenfull ? 'h_panel_max' : 'h_panel_restore']" @click="handle('screen')"><b>全屏</b></a>
      </div>
      <img class="preview-img" :style="{transform: transform}" :src="fileServerPath+viewImg" />
      <!--Array.prototype.isPrototypeOf([])-->
      <template v-if="imgList.length > 0">
        <Icon custom="h_arrows_left"
              class="preview-arrow-btn preview-arrow-btn-left"
              :class="{'btnDisabled': curentIdx == '0'}"
              @click.stop="arrowBtnFun('prev')"
        ></Icon>
        <Icon custom="h_arrows_right"
              class="preview-arrow-btn preview-arrow-btn-right "
              :class="{'btnDisabled': curentIdx == (imgList.length-1)}"
              @click.stop="arrowBtnFun('next')"
        ></Icon>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: "imgPreview",
    data(){
      return {
        fileServerPath: "",
        scale: 0,
        rotate: 0,
        screenfull: false,
        // 当前展示图片位置
        curentIdx: 0,
        imgList: [],
        viewImg: '',
      }
    },
    computed: {
      transform(){
        return 'rotate('+90*this.rotate +'deg) scale('+(1+0.2*this.scale)+')'
      },
      imgDate: {
        get() {
          return this.$store.state.viewImg
        }
      }
    },
    watch:{
      imgDate: {
        handler(newVal) {
          let _imgs = newVal;
          if(_imgs.imgList && _imgs.imgList.length > 0) {
            this.curentIdx = _imgs.idx;
            this.imgList = _imgs.imgList;
            this.viewImg = _imgs.imgList[_imgs.idx].showImg || _imgs.imgList[_imgs.idx].imgUrl || '';
          } else {
            this.curentIdx = 0;
            this.imgList = [];
            this.viewImg = _imgs;
          }
        },
        deep: true
      },
    },
    methods: {
      handle(flg){
        if(flg == 'reset'){
          this.scale = 0;
          this.rotate = 0;
        }else if(flg == 'scalesmall'){
          this.scale--;
        }else if(flg == 'scalelarge'){
          this.scale++;
        }else if(flg == 'rotate'){
          if(this.rotate>2){
            this.rotate = 0;
          }else{
            this.rotate++;
          }
          let de = this.rotate;
        }else if(flg == 'screen'){
          this.screenfull = !this.screenfull;
        }
      },
      closeImg(){
        this.scale = 0;
        this.rotate = 0;
        this.screenfull = false;
        this.$store.commit('viewImgChange', '');
      },
      arrowBtnFun(lx) {
        if(lx == 'prev') {
          // prev
          if(this.curentIdx > 0) {
            this.curentIdx--;
            this.$set(this, 'viewImg', this.imgList[this.curentIdx].showImg || this.imgList[this.curentIdx].imgUrl);
          }
        } else {
          // next
          if(this.curentIdx < this.imgList.length-1) {
            this.curentIdx++;
            this.$set(this, 'viewImg', this.imgList[this.curentIdx].showImg || this.imgList[this.curentIdx].imgUrl);
          }
        }
      }
    }
  }
</script>

<style scoped>
  .preview-mask{
    background-color: rgba(55,55,55,.6);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .preview-wrap{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 100%;
    display: flex;
    text-align: center;
    z-index: 10010;
    background: rgba(95, 95, 95, 0.95);
    border: 0px solid #aaa;
    box-shadow: 0 0 6px 6px;
    border-radius: 0px;
    overflow: hidden;
  }
  .preview-wrap-full{
    width: 100%;
  }
  .preview-wrap img{
    position: relative;
    width: auto;
    height: 100%;
    margin: 0 auto;
    align-self: center;
  }
  .preview-wrap img:active{
    cursor: all-scroll;
  }
  .preview-title{
    width: 100%;
    height: 32px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    color: #fff;
    background: rgba(1,1,1,0.6);
  }
  .preview-title-p {
    text-align: left;
    padding-left: 10px;
    line-height: 32px;
    font-weight: 600;
    font-size: 13px;
    float: left;
    width: 50%;
    color: #f1f1f1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .preview-title>a {
    font-size: 16px;
    font-weight: bold;
    float: right;
    background: transparent;
    border-radius: 0;
    width: 68px;
    line-height: 30px;
    text-align: center;
    color: #f1f1f1;
    -webkit-user-select: none;
  }
  .preview-title>a.h_cancel{
    width: 36px;
  }
  .preview-title>a>b{
    font-size: 14px;
    font-weight: normal;
    margin: 6px;
    vertical-align: 2px;
  }
  .preview-arrow-btn {
    position: absolute;
    top: calc(50% - 15px);
    display: block;
    padding: 20px 6px;
    text-align: center;
    font-size: 26px;
    color: #ffffff;
    background-color: rgba(0,0,0,0.5);
    border-radius: 2px;
    cursor: pointer;
  }
  .preview-arrow-btn:hover {
    background-color: rgba(0,0,0,0.2);
  }
  .preview-arrow-btn.btnDisabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
  .preview-arrow-btn-left {
    left: 10px;
  }
  .preview-arrow-btn-right {
    right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/new/common/imgPreview.vue